module.exports = __webpack_public_path__ + "img/IMG_20191126_235448.e0d198e0.jpg";